import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { textLObj } = typographyStyles;
const { fontSize } = typographyStyles;
const { ui } = constants.colors;
const neutral400 = ui.neutral[400];
const neutral600 = ui.neutral[600];

export const collapseBtnCss = {
  Button: {
    root: { width: "100%" },
  },
};

export const formativeHeaderCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "8px",
  marginBottom: "20px",
  width: "100%",
};

export const headingCss: CSSObject = {
  ...textLObj,
  ...fontSize.heading4,
  margin: 0,
  color: neutral600,
  textAlign: "left",
  lineHeight: "1.5rem",
};

export const formativeIconCss: CSSObject = {
  flexShrink: 0,
};

export const formativeDescriptionCss: CSSObject = {
  ...fontSize.textS,
  color: neutral600,
  margin: "0 0 1rem",
};

export const iconCss: CSSObject = {
  height: "24px",
  marginLeft: "auto",
  width: "24px",

  path: {
    stroke: neutral400,
    strokeWidth: "3px",
  },
};
